import { useState } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { toast } from "../../utils/toast";
import { Button, Input } from "../ui";
import { bursariesApi } from "../../api/hliLists";
import { errorMessageOf } from "../../api/scholarships";
import { TOAST } from "./shared";

// Corrects the national ID and phone number on the student's bursary record
export default function ContactTab({ record, onUpdated }) {
  const [nationalId, setNationalId] = useState(record.nationalId || "");
  const [phoneNumber, setPhoneNumber] = useState(record.phoneNumber || "");
  const [busy, setBusy] = useState(false);

  const update = async (event) => {
    event.preventDefault();
    if (!nationalId.trim() || !phoneNumber.trim()) {
      toast.warning("Please, provide your national ID and phone number", TOAST);
      return;
    }
    setBusy(true);
    try {
      const { data } = await bursariesApi.correctContact({ nationalId: nationalId.trim(), phoneNumber: phoneNumber.trim() });
      toast.success("Your national ID and phone number are successfully updated", TOAST);
      onUpdated(data);
    } catch (error) {
      console.error("Failed to update the contact details", error);
      toast.error(errorMessageOf(error, "National ID and phone number not updated"), TOAST);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={update} className="flex max-w-xl flex-col gap-5">
      <Input label="Registration number" value={record.registrationNumber || ""} readOnly />
      <Input label="National ID" required value={nationalId} onChange={(e) => setNationalId(e.target.value)} />
      <Input label="Phone number" required type="tel" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
      <Button type="submit" loading={busy} icon={<CheckIcon className="h-4 w-4" />}>
        Update
      </Button>
    </form>
  );
}
